import firebase from "firebase/app";
import "firebase/messaging";

import { post_user_push_token } from "./http";

const config = {
    apiKey: "AIzaSyA2mD8f-ZIYn8d0d4J8TxHQ8SG3ZPZnGp8",
    authDomain: "voda-monitoring.firebaseapp.com",
    databaseURL: "https://voda-monitoring.firebaseio.com",
    projectId: "voda-monitoring",
    storageBucket: "voda-monitoring.appspot.com",
    messagingSenderId: "191453546638"
};


export const initializeFirebase = () => {
    firebase.initializeApp(config)
};

export const initializePush = (auth_token) => {
    const messaging = firebase.messaging();
    if (localStorage.getItem("push_granted") === null) {
        messaging
            .requestPermission()
            .then(() => {
                return messaging.getToken();
            })
            .then(token => {
                localStorage.setItem("push_granted", "true");
                post_user_push_token(auth_token, token);

            }).catch(error => {
            if (error.code === "messaging/permission-blocked") {
                localStorage.setItem("push_granted", "false");
            }
        })
    }
};


// WEBPACK FOOTER //
// ./src/utils/pushNotifications.js